import { difference } from 'lodash'

import { DeckLeglaity, LegalityChecker } from '../deckLegality'
import { ERRORS } from '../legality.const'

const CheckLegality: LegalityChecker = (deck: DeckLeglaity) => {
  const hasCommander = deck.checkHasCommander()

  deck.checkCanBeCommander()
  deck.checkPartners()
  deck.checkLegendaryCommander()
  deck.checkMaximumCommanders()
  deck.checkEDHBracket()

  const fullDeck = [...deck.mainboard, ...deck.commanders] // combining to check legality of all cards included in the deck

  for (const card of fullDeck) {
    if (!hasCommander) break // Override here. We don't check color identity if there is no commander because it causes a lot of scary errors

    deck.checkCardLegality(card)
    deck.checkCardQuantity(card, 1)

    const colorDiff = difference(card.colorIdentity, deck.commandersColorIdent)

    if (colorDiff.length) deck.addCardError(ERRORS.OUTSIDE_COLOR_IDENTITY, card)
  }

  if (deck.deckSize !== 100) deck.addError(ERRORS.COMMANDER_SIZE)
}

export default CheckLegality
